module.exports = __webpack_public_path__ + "nucleo-outline.8ebec31f5ce59f908db8.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/assets/fonts/nucleo-outline.woff2
// module id = ../../../../../src/assets/fonts/nucleo-outline.woff2
// module chunks = 17